<script setup>
import { ref } from 'vue';
import BitrixGuideSidePanel from '@/components/CreateConnectionComponents/BitrixUpload/components/BitrixGuideSidePanel.vue';
import BitrixAccountLinkGuide from '@/components/CreateConnectionComponents/BitrixUpload/components/BitrixAccountLinkGuide.vue';

const isGuideOpen = ref(false);

function openGuide() {
    isGuideOpen.value = true;
}
</script>

<template>
    <button
        type="button"
        class="flex items-center gap-2 px-3 py-2 border border-blue-200 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors duration-150"
        @click.stop="openGuide"
    >
        <svg class="w-4 h-4 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
        </svg>
        <span class="text-[11px] sm:text-xs font-semibold leading-tight text-left">
            Как привязать аккаунт Битрикс24
        </span>
    </button>

    <BitrixGuideSidePanel
        v-model="isGuideOpen"
        title="Как привязать аккаунт Битрикс24"
    >
        <BitrixAccountLinkGuide />
    </BitrixGuideSidePanel>
</template>
